<template>
  <div>
    <vue-element-loading :active="!show" :is-full-screen="true" />
    <div v-if="show">
      <OrdersList class="mt-4" v-if="transaction" :static_items="[transaction]" show_order_detail />

      <b-container fluid class="p-0 mt-4">
        <b-row>
          <b-col cols="12" md="9">
            <b-row>
              <b-col cols="12">
                <h4
                  class="text-uppercase mb-0 border-top border-left border-right p-3"
                >{{ pharmacy && pharmacy.public_name }}</h4>
                <VDrugsSummary
                  v-if="transaction && transaction.item_list"
                  :items="transaction.item_list.drugs"
                  picturecolumn
                  taxcolumn
                  discountcolumn
                  totalcolumn
                  :showamount="false"
                  class="order-summary border"
                />
              </b-col>
            </b-row>
            <b-row
              v-if="(
                transaction &&
                  transaction.documentation &&
                  transaction.documentation.documents &&
                  transaction.documentation.documents.length > 0
              )"
            >
              <b-col cols="12" class="pt-5">
                <h4
                  class="text-uppercase mb-0 border-top border-left border-right p-3"
                >{{ $t('transaction_details.documents_title') }}</h4>
                <VDocumentCardList
                  class="p-4 border"
                  :documents="transaction.documentation.documents"
                />
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="3">
            <div class="d-flex justify-content-center">
              <b-button
                v-if="bankPaymentTransaction"
                v-b-modal.deposit-reference
                variant="primary"
                class="mb-4 px-5"
              >{{ $t("transaction_details.reference_deposit") }}</b-button>
            </div>
            <b-modal
              id="deposit-reference"
              ref="deposit-reference"
              centered
              hide-footer
              :title="$t('transaction_details.reference_deposit')"
            >
              <TransactionDetailBankDeposit
                :payment_transaction="bankPaymentTransaction"
                @input="onBankDeposit"
              />
            </b-modal>
            <TotalAmountSummary
              v-if="transaction && transaction.amount && transaction.item_list"
              :items="transaction.item_list.drugs"
              :title="$t('transaction_details.n_products', { nProducts: productsQuantity })"
              :amount="new amount_object(transaction.amount)"
            />
          </b-col>
        </b-row>

        <b-row class="border mt-5 p-3">
          <b-col cols="12" md="3" v-if="delivery_address" class="transaction-detail">
            <TransactionDetailDelivery :address="delivery_address" />
          </b-col>
          <b-col cols="12" md="3" v-if="transaction && transaction.payment" class="transaction-detail">
            <TransactionDetailPayment :payment="transaction.payment" class="mt-4 mt-md-0" />
          </b-col>
          <b-col cols="12" md="3" v-if="transaction && transaction.delivery" class="transaction-detail">
            <TransactionDetailShipping :shipping="transaction.delivery" class="mt-4 mt-md-0" />
          </b-col>
          <b-col cols="12" md="3" v-if="patient" class="transaction-detail">
            <TransactionDetailPatient :patient="patient" class="mt-4 mt-md-0" />
            <TransactionDetailImportationData
              v-if="transaction.importation"
              :importation="transaction.importation"
              class="pt-3 mt-4 mt-md-0"
            />
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import OrdersList from "@/components/OrdersList";
import TotalAmountSummary from "@/components/TotalAmountSummary";
import TransactionDetailDelivery from "@/components/TransactionDetailDelivery";
import TransactionDetailPayment from "@/components/TransactionDetailPayment";
import TransactionDetailPatient from "@/components/TransactionDetailPatient";
import TransactionDetailImportationData from "@/components/TransactionDetailImportationData";
import TransactionDetailBankDeposit from "@/components/TransactionDetailBankDeposit";
import TransactionDetailShipping from "@/components/TransactionDetailShipping";
import VDocumentCardList from "@/components/VDocumentCardList";

import VDrugsSummary from "@/components/VDrugsSummary";

import get from "lodash/get";

import { mapState } from "vuex";
import { Amount } from "@/lib/amount.js";
import { getDrugsQuantity } from "@/lib/drugs.js";

export default {
  name: "transaction-detail",
  components: {
    VDrugsSummary,
    OrdersList,
    TotalAmountSummary,
    TransactionDetailDelivery,
    TransactionDetailPayment,
    TransactionDetailPatient,
    TransactionDetailImportationData,
    TransactionDetailBankDeposit,
    TransactionDetailShipping,
    VDocumentCardList,
  },
  data() {
    return {
      amount_object: Amount,
      show: true,
      transaction: undefined,
      delivery_address: undefined,
    };
  },
  props: {
    transaction_uuid: {
      default: undefined,
      type: String,
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        transaction_details: {
          reference_deposit: "Reference deposit",
          n_products: "Products ({nProducts})",
          bank_deposit_set: "Bank deposit reference registered",
          documents_title: "Documents",
          error: {
            bank_deposit_set: "Error when registering bank deposit reference",
          },
        },
      },
    },
  },
  computed: {
    ...mapState({
      latest_params: state => state.routehelper.latest_params,
    }),
    pharmacy() {
      if (!this.transaction) {
        return undefined;
      }
      return this.transaction.party.participants.filter(p => {
        // Search seller participant
        return p.role == 2;
      })[0].person.organization;
    },
    patient() {
      if (!this.transaction) {
        return undefined;
      }
      return this.transaction.party.participants.filter(p => {
        // Search buyer participant
        return p.role == 1;
      })[0].person.patient;
    },
    bankPaymentTransaction() {
      // Transacciones de pago que se realizan a través del banco
      if (this.transaction && this.transaction.payment) {
        return this.transaction.payment.transactions.filter(
          transaction =>
            transaction.payment_method.payment_method === 4 &&
            !transaction.service_bank_deposit_done
        )[0];
      }
      return undefined;
    },
    productsQuantity() {
      // Suma de todas las cantidades, contando packs también
      return getDrugsQuantity(this.transaction.item_list.drugs);
    },
  },
  mounted: function() {
    this.loadOrder();
  },
  methods: {
    loadOrder() {
      // vuelve a cargar la lista de reembolsos borrador
      this.$store
        .dispatch("drugtransaction/REQUEST_RETAIL_ORDER", {
          order_uuid: this.transaction_uuid,
        })
        .then(
          response => {
            this.transaction = response.data;

            this.delivery_address = {
              name: get(response.data, "recipe.patient_address.name", ""),
              email: get(response.data, "delivery.delivery_address.email", ""),
              address: get(response.data, "delivery.delivery_address.address"),
              colony: get(response.data, "delivery.delivery_address.colony"),
              town: get(response.data, "delivery.delivery_address.town"),
              country: get(response.data, "delivery.delivery_address.country"),
              federal_entity: get(
                response.data,
                "delivery.delivery_address.federal_entity"
              ),
              postal_code: get(
                response.data,
                "delivery.delivery_address.postal_code"
              ),
              phone: get(response.data, "delivery.delivery_address.phone"),
              mobile: get(response.data, "delivery.delivery_address.mobile"),
            };
            this.show = true;
            if (!response) {
              this.orderNotFound();
            }
          },
          err => {
            this.$sentry({ capture: err });
            //this.$router.push({ name: "fallback-error-page" });
          }
        );
    },
    orderNotFound() {
      this.show = true;
      this.mnotify_error({
        text: this.$t("refund_home.error.refound_not_found"),
      });
      this.$router.push({
        name: "nopatient_refund_insurance_selection",
        params: {
          pt_uuid: this.latest_params.pt_uuid,
        },
      });
    },
    onBankDeposit(bankDepositData) {
      this.$refs["deposit-reference"].hide();
      this.$store
        .dispatch("drugtransaction/SET_BANK_DEPOSIT_REFERENCE", {
          order_uuid: this.transaction_uuid,
          payment_transaction_uuid: this.bankPaymentTransaction.uuid,
          payment_reference: bankDepositData.payment_reference,
          SEC: bankDepositData.SEC,
          sheet: bankDepositData.sheet,
          date: bankDepositData.date,
          remitter: bankDepositData.remitter,
          amount: bankDepositData.amount,
        })
        .then(
          () => {
            this.mnotify_success({
              text: this.$t("transaction_details.bank_deposit_set"),
            });
            this.loadOrder();
          },
          err => {
            this.$sentry({ capture: err });
            this.mnotify_error({
              text: this.$t("transaction_details.error.bank_deposit_set"),
            });
          }
        );
    },
  },
};
</script>

<style lang="scss" scoped>
.order-summary ::v-deep th {
  border-bottom-color: $border-color;
}

.transaction-detail:not(:first-child) {
  border-left: 1px solid $border-color;
  @include media-breakpoint-down(md) {
    border-left: 0;
  }
}
</style>
